// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const FormLabel = styled.span`
    span:first-child {
        font-size: 14px !important;
    }
`;
